module.exports = {
  info: 'Перетащите загружаемый файл в эту область или',
  info_button: 'выберите на диске',
  upload_csv: 'Загрузить метаданные в формате файла CSV',
  max_length_error:
    'Превышено максимально допустимое количество символов в названии. Лимит 64 символа.',
};
